// extracted by mini-css-extract-plugin
export default {"link":"MW3RYk","root":"G43yBY","label":"XFBBBz"};